import Input from "./components/Input";
import styled, { css } from "styled-components";
import PokeBall from "./assets/Balls/comuns/poke-ball.png";
import GreaterBall from "./assets/Balls/comuns/great-ball.png";
import SuperBall from "./assets/Balls/comuns/super-ball.png";
import UltraBall from "./assets/Balls/comuns/ultra-ball.png";
import SpecialBalls from "./assets/Balls/especiais/pokebolas-especiais.gif";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Expand from "react-expand-animated";
import { Oval } from "react-loader-spinner";

const MainDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const PokemonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 25px;
  @media (max-width: 768px) {
    align-items: center;
  }
`;

const MediaValue = styled.span`
  padding: 2px;
  color: #00222e;
  font-size: 1.2rem;
`;

const DivPoke = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgb(121, 202, 249);
  cursor: pointer;
  ${(props) =>
    props.isSelected
      ? css`
          border: 3px dashed rgba(227, 114, 114, 1);
        `
      : css`
          border: 2px solid rgb(106, 146, 242);
        `};
  border-radius: 2.5vh;
  width: 150px;
  font-size: 8px;
  margin: 12px;
  padding: 12px;

  &&:hover {
    border-color: white;
  }

  &&:focus {
    border-color: red;
  }

  h1 {
    font-weight: bold;
  }
`;

const DivPokeContent = styled.div`
  font-size: 16px;
  width: 100%;
`;

const DivPokeBalls = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  width: 100%;
  font-size: 20px;
`;

const PokeImg = styled.img`
  width: 25%;
  padding: 5px;
`;

const Card = styled.div`
  img {
    border-radius: 50px;
  }
`;

const LoadingDiv = styled.div`
  display: flex;
  justify-content: center;
  div {
    position: fixed;
    top: 50%;
    left: 50%;
    /* transform utilizado para se basear no tamanho do elemento, ficando bem centralizado. */
    transform: translate(-50%, -50%);
  }
`;

const MoreInfo = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  font-size: 1rem;
  border: 1px solid #e6e4f9;
  border-radius: 50px;
  width: 20px;
  display: flex;
  justify-content: center;
  background-color: #f3f9f9;
  color: #6a92f2;
  font-weight: bold;
`;

const PokeTitle = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  align-items: space-between;
  justify-content: center;
`;

function App() {
  const [pokes, setPokes] = useState([]);
  const [pokesSearch, setPokesSearch] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const elRef = useRef([]);
  const [selectedPoke, setSelectedPoke] = useState(null);
  const [expanded, setExpanded] = useState([]);

  const client = axios.create({
    baseURL: "https://ruby-pxg.herokuapp.com",
  });

  // Sets the page title
  useEffect(() => {
    document.title = "PxG - Média de Catch";
  }, []);

  // Effect that gets the pokemons and set to state
  useEffect(() => {
    const getPokes = async () => {
      const res = await client.get("/pokes");
      const results = res.data;

      const pokeBalls = [
        {
          type: "Normal",
          img: PokeBall,
          price: 5,
        },
        {
          type: "Greater",
          img: GreaterBall,
          price: 20,
        },
        {
          type: "Super",
          img: SuperBall,
          price: 50,
        },
        {
          type: "Ultra",
          img: UltraBall,
          price: 130,
        },
        {
          type: "Special",
          price: 260,
          img: SpecialBalls,
        },
      ];

      // Parse the pokemons and insert balls media on each to use later
      let parsedPokemons = results.map((poke) => {
        const pokeCopy = { ...poke };

        // Add the balls media to the object dinamically
        pokeCopy["mediaBalls"] = pokeBalls.map((ball) => {
          const result = poke?.price / ball?.price;
          const media = Math.round(result * 3);
          return { ...ball, media };
        });

        return pokeCopy;
      });

      setPokes(parsedPokemons);
      setExpanded(parsedPokemons.map(() => false));
      setPokesSearch(
        parsedPokemons?.map((poke, index) => {
          return { id: index, name: poke.name, poke };
        })
      );
    };
    getPokes().then(() => {
      setLoaded(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Adds the ref to each element
  useEffect(() => {
    elRef.current = elRef.current.slice(0, pokes.length);
  }, [pokes]);

  return loaded ? (
    <MainDiv className="App">
      <Input
        pokesList={pokesSearch}
        elRef={elRef}
        setSelectedPoke={setSelectedPoke}
        pokes={pokes}
        expanded={expanded}
        setExpanded={setExpanded}
      />

      <PokemonsWrapper>
        {pokes.map((poke, index) => {
          return (
            <DivPoke
              key={poke.id}
              id={`${poke.name}`}
              ref={(el) => (elRef.current[index] = el)}
              isSelected={selectedPoke === poke}
              onClick={() => {
                let copy = [...expanded];
                copy[index] = !expanded[index];
                setExpanded(copy);
              }}
            >
              <PokeTitle>
                <h1>{poke.name}</h1>
                <MoreInfo
                  onClick={() => {
                    window.open(
                      `https://wiki.pokexgames.com/index.php/${poke.name}`
                    );
                  }}
                >
                  ?
                </MoreInfo>
              </PokeTitle>
              <PokeImg src={poke.image} />
              <DivPokeContent>
                <Expand open={expanded[index]} duration={200}>
                  <DivPokeBalls>
                    {poke?.mediaBalls.map((ball, index) => {
                      return (
                        <Card key={index}>
                          <img alt={ball?.name} src={ball?.img} />
                          <MediaValue>{ball?.media}</MediaValue>
                        </Card>
                      );
                    })}
                  </DivPokeBalls>
                </Expand>
              </DivPokeContent>
            </DivPoke>
          );
        })}
      </PokemonsWrapper>
    </MainDiv>
  ) : (
    <LoadingDiv>
      <div>
        <Oval
          ariaLabel="loading-indicator"
          height={125}
          width={125}
          strokeWidth={1}
          strokeWidthSecondary={1}
          color="#6A92F2"
          secondaryColor="white"
        />
      </div>
    </LoadingDiv>
  );
}

export default App;
